module.exports = __webpack_public_path__ + "static/media/pic12.f6bb7747.png";